import React, { useEffect, useRef, useState } from 'react'
import $ from "jquery";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import jszip from "jszip";
import { Link } from 'react-router-dom';
const RefereeDetail = () => {


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content p-4">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Referee Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Referee Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <section className="referees-dtl">
                        <div className="referee-modal">
                            <div class="back-arrow-new"><a href="/referee-management"><i class="bx bx-arrow-back"></i></a></div>
                            <div className="modal-header-custom">
                                <h5>Referee Details</h5>
                            </div>
                            {/* Personal Details */}
                            <div className="detail-section">
                                <h6>Personal Details</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Name</p>
                                        <p className="value">John Doe</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Email</p>
                                        <p className="value">john.doe@example.com</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Phone Number</p>
                                        <p className="value">+1 234 567 890</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Age</p>
                                        <p className="value">32 years</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Country</p>
                                        <p className="value">United States</p>
                                    </div>
                                </div>
                            </div>
                            {/* Professional Details */}
                            <div className="detail-section">
                                <h6>Professional Details</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Experience Level</p>
                                        <p className="value">Senior (5+ years)</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">License Number</p>
                                        <p className="value">REF-2026-00151</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Match Count</p>
                                        <p className="value">287 matches</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Certifications</p>
                                        <span className="badge bg-success">FIFA Level 2</span>
                                        <span className="badge bg-success">National Badge</span>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Available Seasons</p>
                                        <span className="season-tag">2026</span>
                                        <span className="season-tag">2027</span>
                                    </div>
                                </div>
                            </div>
                            {/* Bank Details */}
                            <div className="detail-section">
                                <h6>Bank Details</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Bank Name</p>
                                        <p className="value">First National Bank</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Account Title</p>
                                        <p className="value">John Michael Doe</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Account Number</p>
                                        <p className="value">****1234</p>
                                    </div>
                                </div>
                            </div>
                            {/* Ratings */}
                            <div className="detail-section">
                                <h6>Ratings &amp; Reviews</h6>
                                <div className="overall-rating">
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star" />
                                    <i className="bx bxs-star-half" />
                                    <span>4.8</span>
                                </div>
                                <div className="review-item">
                                    <div>
                                        <p className="game">Professionalism</p>
                                        <p className="comment">Excellent professionalism</p>
                                    </div>
                                    <div className="review-rating">
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <span>98%</span>
                                    </div>
                                </div>
                                <div className="review-item">
                                    <div>
                                        <p className="game">Punctuality</p>
                                        <p className="comment">Always on time</p>
                                    </div>
                                    <div className="review-rating">
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <span>100%</span>
                                    </div>
                                </div>
                                <div className="review-item">
                                    <div>
                                        <p className="game">Decision Making</p>
                                        <p className="comment">Accurate match decisions</p>
                                    </div>
                                    <div className="review-rating">
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <i className="bx bxs-star" />
                                        <span>95%</span>
                                    </div>
                                </div>
                            </div>
                            {/* Documents */}
                            <div className="detail-section">
                                <h6>Documents</h6>
                                <div className="doc-item">
                                    <i className="bx bx-file" />
                                    <span>Referee License</span>
                                    <i className="bx bx-download download" />
                                </div>
                                <div className="doc-item">
                                    <i className="bx bx-file" />
                                    <span>Background Check Certificate</span>
                                    <i className="bx bx-download download" />
                                </div>
                                <div className="doc-item">
                                    <i className="bx bx-file" />
                                    <span>Resume / CV</span>
                                    <i className="bx bx-download download" />
                                </div>
                            </div>
                            {/* Hiring Status */}
                            <div className="detail-section">
                                <h6>Hiring Status</h6>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="label">Status</p>
                                        <p className="value">Hired</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Scheduled Games</p>
                                        <p className="value">12</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="label">Completed Games</p>
                                        <p className="value">45</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </div>


           

        </>
    )
}

export default RefereeDetail